import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router , RouterLink} from '@angular/router';

import { AuthService } from '../../core/auth.service';

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    RouterLink
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.css'
})
export class LoginComponent {

  email = 'admin@cardapio.com';
  password = '123456';

  loading = false;
  error = '';
  showPassword = false;

  constructor(
    private auth: AuthService,
    private router: Router
  ) {}


    togglePasswordVisibility(): void {
    this.showPassword =
      !this.showPassword;
  }

  // login(): void {
  //   this.loading = true;
  //   this.error = '';

  //   this.auth.login(this.email, this.password).subscribe({
  //     next: () => {
  //       this.loading = false;
  //       this.router.navigate(['/admin']);
  //     },
  //     error: (e) => {
  //       this.loading = false;
  //       this.error = e?.error?.message || 'Erro ao entrar.';
  //     }
  //   });
  // }


login(): void {
  this.loading = true;
  this.error = '';

  this.auth
    .login(
      this.email,
      this.password
    )
    .subscribe({

      next: () => {

        this.loading = false;

        if (
          this.auth.isSuperAdmin()
        ) {
          this.router.navigate([
            '/superadmin'
          ]);

          return;
        }

        this.router.navigate([
          '/admin'
        ]);
      },

      error: (e) => {

        this.loading = false;

        this.error =
          e?.error?.message ||
          'Erro ao entrar.';
      }

    });
}

}